import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute} from '@angular/router'
import {CarrinhoItemsModel} from '../../../../../models/carrinhoItems.model'
import {UsersService} from '../../../../../models/usuarios.service'
import { QueryFn } from 'angularfire2/firestore';
import { Formatter } from '../../../../../comum/pipes/formatter';
import {EstadoItens} from '../../../../../models/estadoItens.model'


@Component({
  selector: 'app-vendas-detalhe',
  templateUrl: './vendas-detalhe.component.html',
  styleUrls: ['./vendas-detalhe.component.scss']
})
export class VendasDetalheComponent implements OnInit,OnDestroy {

  nPedido = 0
  dataSource : Array<any>
  estadosModel : EstadoItens
  pedidoModel : CarrinhoItemsModel
  colunas = ['codigo','nome','qtde','valor','total','estado']
  estados : Array<any>
  constructor(
    private route : ActivatedRoute,
    private usersService : UsersService
  )
  {
      this.estadosModel = new EstadoItens(usersService.usuarioClass.dbConn)
      this.pedidoModel = new CarrinhoItemsModel(usersService.usuarioClass.dbConn,this.usersService)
      this.route.params.subscribe(params => { this.nPedido = params['pedido']  })
  }

  ngOnInit() 
  {
    this.estadosModel.snapshot(
      (elem) => { return elem.where('inativo','==',false) },
      (data) =>
      { 
        this.estados = data 
        this.carregarPedido()
      }
      ,true)
  }

  carregarPedido()
  {
      this.pedidoModel.pedidoClass.snapshot(this.where(),
      (data)=>{
         let pedidos : Array<any> = []
         //['codigo','nome','qtde','valor','total','estado']
         for(let elem of data)
         {
             let estado = this.estadoPorCodigo(elem.estado)
             pedidos.push({
               codigo : elem.produto,
               nome : elem.nome, 
               qtde : CarrinhoItemsModel.formatQtde(elem.qtde), 
               valor : Formatter.formatMoney(elem.precoVenda), 
               total : Formatter.formatMoney( elem.total || elem.valor ),
               estado : estado ? estado.nome : elem.estado
             }) 
         }
         this.dataSource = pedidos
      },
    true)
  }

  estadoPorCodigo(estado)
  {
    let estados = this.estados.filter(function(item){ return(item.codigo == estado)   })
    if(estados && (estados.length > 0))
      return estados[0] 
  }

  where() : QueryFn 
  {
    let where : QueryFn 

    if(this.usersService.fornecedor == 0)
    {
        where = (elem)=>{ return elem.where('pedido','==',this.nPedido)   }
    }
    else 
    {
        where = (elem)=>{ 
          return elem.where('pedido','==',this.nPedido)  
          .where('fornecedor','==',this.usersService.fornecedor)
         }
    }
    return where
  }

  ngOnDestroy()
  {
    
  }

}
